import axios from "axios";
import { getExplorePlacesUrl, getExploreSearchHistoryUrl, getExploreSearchProgressUrl, getExploreSearchUrl, getExploreRecordInteractionUrl } from "./ServiceUrls";
import { createClient } from "@supabase/supabase-js";

const supabase = createClient('https://twblyxzvdbhlhxxurpno.supabase.co', 'eeyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR3Ymx5eHp2ZGJobGh4eHVycG5vIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAzNDMzNTMsImV4cCI6MjA3NTkxOTM1M30.cOz8DeHN7L00i3VN2wF5NXs2quw95Eaz3-8IQs4ltgw')

export default class ExploreRepository {

    async recordInteraction(placeId) {
        const session = await supabase.auth.getSession()
        try {
            const response = await axios.post(getExploreRecordInteractionUrl(placeId), {}, {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            });
            return response.data
        } catch (err) {
            return err.response.data
        }
    }

    async getExplorePlaces(offset, seed, tags, googlePlaceId, bounds, placeName, ipInferredCityName, sortType, currentLocation) {
        const session = await supabase.auth.getSession()
        try {
            const response = await axios.get(
                getExplorePlacesUrl(offset, seed, tags, googlePlaceId, bounds, placeName, ipInferredCityName, sortType, currentLocation),
                {
                    headers: {
                        'Authorization': `Bearer ${session.data.session.access_token}`
                    }
                }
            );
            return response.data
        } catch (err) {
            return err.response.data
        }
    }

    async getExploreSearchProgress(clientSearchId) {
        const session = await supabase.auth.getSession()
        try {
            const response = await axios.get(getExploreSearchProgressUrl(clientSearchId), {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            })
            return response.data
        } catch (err) {
            console.log(`getExploreSearchProgress error ${err.response.data}`)
            return null
        }
    }

    async getExploreSearchHistory() {
        const session = await supabase.auth.getSession()
        try {
            const response = await axios.get(getExploreSearchHistoryUrl(), {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`  
                }
            })
            return response.data
        } catch (err) {
            return err.response.data
        }
    }

    async getExploreSearch(
        queryInput, 
        offset, 
        seed, 
        googlePlaceId, 
        bounds, 
        placeName, 
        currentLocation, 
        ipInferredCityName, 
        extractedSearchQueryParameters,
        searchId
    ) {
        const session = await supabase.auth.getSession()
        try {
            const response = await axios.post(
                getExploreSearchUrl(queryInput, offset, seed, googlePlaceId, bounds, placeName, currentLocation, ipInferredCityName, searchId),
                {
                    extractedSearchQueryParameters: extractedSearchQueryParameters
                },
                {
                    headers: {
                        'Authorization': `Bearer ${session.data.session.access_token}`
                    }
                }
            );
            return response.data
        } catch (err) {
            return err.response.data
        }
    }
}
